import { ReactNode } from 'react';

import { IconCheckCircleOutline } from '@iwoca/icons';
import { useLingui } from '@lingui/react/macro';

import styles from './CompanySelected.module.css';
import ButtonLink from '../../../../ButtonLink/ButtonLink';
import { StepLayout } from '../../../StepLayout/StepLayout';
import { legalFormLabel, TCompanyMatch } from '../companyData';

// DIT-681. Register-confirmation step, shown once the legal-form lookup resolves.
export const CompanySelected = ({
  company,
  legalForm,
  onConfirm,
  onDeselect,
}: {
  company: TCompanyMatch;
  legalForm?: string;
  onConfirm: () => void;
  onDeselect: () => void;
}) => {
  const { t } = useLingui();

  return (
    <StepLayout
      stageTitle={t`Business details`}
      heading={t`Is this company selection correct?`}
      onContinue={onConfirm}
    >
      <div className={styles.card}>
        <p className={styles.cardHead}>
          <IconCheckCircleOutline className={styles.cardHeadIcon} />
          {t`Successfully retrieved`}
        </p>
        <Row label={t`Limited company`} value={company.name} />
        <Row
          label={t`Address`}
          value={`${company.street} ${company.house_number}, ${company.postcode} ${company.city}`}
        />
        <Row label={t`Legal form`} value={legalFormLabel(legalForm)} />
        <div className={styles.cardFoot}>
          <ButtonLink className={styles.deselectLink} onClick={onDeselect}>
            {t`Not my company`}
          </ButtonLink>
        </div>
      </div>
    </StepLayout>
  );
};

const Row = ({ label, value }: { label: string; value: ReactNode }) => (
  <div className={styles.cardRow}>
    <span>{label}</span>
    <b>{value}</b>
  </div>
);
